import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpPostSendForApproval = createApi(`GMPSendForApprovalSlice`,"POST");

const GMPSendForApprovalSlice = createSlice({
  name: 'GMPSendForApprovalSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpPostSendForApproval.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpPostSendForApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpPostSendForApproval.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPSendForApprovalSlice.reducer;